import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isUserAuthenticated } from "../api/userApi";
import { useUser } from "../context/userContext";
import NotFound from "../components/common/notFound";

export function useUserAuth() {
    const token = localStorage.getItem("Token");
    const location = useLocation();

    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [authChecked, setAuthChecked] = useState(false);

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const response = await isUserAuthenticated();

                if (response.status === 200) {
                    setIsAuthenticated(true);
                }
            }
            catch (error) {
                setIsAuthenticated(false);
                localStorage.clear();
            }
            setAuthChecked(true);
        }
        checkAuth();
    }, [token, location.pathname]);

    return { isAuthenticated, authChecked };
}

export function ProtectedRoute({ children, requiredRoles = [] }) {
    const { user } = useUser();
    const { isAuthenticated, authChecked } = useUserAuth();

    const userRoles = JSON.parse(localStorage.getItem("Roles"));

    if (!authChecked) {
        return (
            <div style={{ textAlign: "center", marginTop: "40px" }}>
                <div className="spinner"></div>
                <span>Loading...</span>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/" replace />;
    }
    else {
        // Check if user has roles array
        if (!userRoles || !Array.isArray(userRoles)) {
            console.warn('User roles not found or invalid:', user);
            return <Navigate to="/" replace />;
        }

        const hasRequiredRole = requiredRoles.length === 0 ||
            requiredRoles.some(role => userRoles.includes(role));

        if (!hasRequiredRole) {
            return <NotFound />;
            // return <Navigate to="/dashboard" replace />;
        }

        return children;
        // return isAuthenticated ? children : <Navigate to="/" replace />;
    }


    // if (Array.isArray(requiredRoles) && requiredRoles.length > 0) {
    //     hasAccess = requiredRoles.some(role => userRoles.includes(role));
    //     if (isAuthenticated && !hasAccess) {
    //         return <Navigate to="/sales" replace />;
    //     }
    // }
}